/* Eight spokes on a shared pulse, each offset by an eighth of the cycle — the
   "rotation" is a travelling wave. */

.base,
.base *,
.base *::before,
.base *::after {
  box-sizing: border-box;
}

.base {
  /* Component-local: the global --duration-* scale is for UI transitions. */
  --spinner-cycle: 900ms;

  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: var(--spinner-size);
  height: var(--spinner-size);
  color: inherit;
}

/* ── Sizes ── */

.xs {
  --spinner-size: var(--space-4);
}

.sm {
  --spinner-size: var(--space-6);
}

.md {
  --spinner-size: var(--space-8);
}

.lg {
  --spinner-size: var(--space-12);
}

.spoke {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.spoke::before {
  content: '';
  width: 20%;
  height: 20%;
  border-radius: var(--radius-round);
  background-color: currentColor;
  transform: scale(0);
  opacity: 0.5;
  animation: spokePulse var(--spinner-cycle) ease-in-out infinite;
}

@keyframes spokePulse {
  0%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
}

.spoke:nth-child(2) {
  transform: rotate(45deg);
}
.spoke:nth-child(3) {
  transform: rotate(90deg);
}
.spoke:nth-child(4) {
  transform: rotate(135deg);
}
.spoke:nth-child(5) {
  transform: rotate(180deg);
}
.spoke:nth-child(6) {
  transform: rotate(225deg);
}
.spoke:nth-child(7) {
  transform: rotate(270deg);
}
.spoke:nth-child(8) {
  transform: rotate(315deg);
}

/* Negative delays start each spoke mid-cycle, so the wave runs from first paint. */
.spoke:nth-child(2)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.875);
}
.spoke:nth-child(3)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.75);
}
.spoke:nth-child(4)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.625);
}
.spoke:nth-child(5)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.5);
}
.spoke:nth-child(6)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.375);
}
.spoke:nth-child(7)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.25);
}
.spoke:nth-child(8)::before {
  animation-delay: calc(var(--spinner-cycle) * -0.125);
}

@media (prefers-reduced-motion: reduce) {
  .spoke::before {
    animation: none;
    transform: scale(1);
    opacity: 0.5;
  }
}
